export enum CartStatus {
  OPENING = 'OPENING',
  PAYING = 'PAYING',
  PAYED = 'PAYED'
}
